import React from 'react';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';
import 'typeface-open-sans';
import store, { history } from './store';
import theme from './theme';
import * as serviceWorker from './serviceWorker';
import PalliativeCareRoot from './modules/App';
import { registerHeadlessBackgroundGeolocationTaskIfMobile } from './modules/Geolocation';

// This is needed to change the CSS injection order so that styled-components
// can modify the Material UI styles
import JssProvider from 'react-jss/lib/JssProvider';
import { create } from 'jss';
import {
  createGenerateClassName,
  jssPreset,
  MuiThemeProvider,
} from '@material-ui/core/styles';

const generateClassName = createGenerateClassName();
const jss = create(jssPreset());
// The custom insertion point that JSS will look for to inject the styles in the DOM
jss.options.insertionPoint = document.getElementById('jss-insertion-point');

ReactDOM.render(
  <Provider store={store}>
    <JssProvider generateClassName={generateClassName} jss={jss}>
      <MuiThemeProvider theme={theme}>
        <ConnectedRouter history={history}>
          <PalliativeCareRoot />
        </ConnectedRouter>
      </MuiThemeProvider>
    </JssProvider>
  </Provider>,
  document.getElementById('root'),
);

registerHeadlessBackgroundGeolocationTaskIfMobile();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();



// WEBPACK FOOTER //
// ./src/index.js